<template>
  <Btn :label="$t('ELE0015')" icon="mdi-magnify" @click="onClick" :disabled="disabled" />
</template>

<script>
import Btn from '@/components/atoms/base/button/Btn'

export default {
  name: 'BtnSearch',

  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  components: {
    Btn,
  },

  methods: {
    onClick() {
      this.$emit('click')
    },
  },
}
</script>
